const Survey = () =>
  import(
    /* webpackChunkName: "questionnaire-survey" */ '@/pages/questionnaire/survey/index.vue'
  )

const CreateSurvey = () =>
  import(
    /* webpackChunkName: "questionnaire-survey" */ '@/pages/questionnaire/survey/create.vue'
  )

const EditSurvey = () =>
  import(
    /* webpackChunkName: "questionnaire-survey" */ '@/pages/questionnaire/survey/edit.vue'
  )

export default {
  path: 'survey',
  meta: {
    label: 'survey',
    auth: 'survey'
  },
  component: {
    name: 'Survey',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'QuestionnaireSurvey',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Survey
    },
    {
      name: 'QuestionnaireCreateSurvey',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSurvey
    },
    {
      name: 'QuestionnaireEditSurvey',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSurvey,
      props: true
    }
  ]
}
